import i18n from 'src/i18n';
import en from './en.json';
import ar from './ar.json';
import ur from './ur.json';
import hi from './hi.json';
import fr from './fr.json';

export const NAMESPACE = 'help-and-support';

const bundles: Record<string, Record<string, string>> = { en, ar, ur, hi, fr };
Object.entries(bundles).forEach(([lng, resources]) => {
  // deep merge, do not overwrite if a key already exists
  i18n.addResourceBundle(lng, NAMESPACE, resources, true, false);
});
